const Languages = [
    {value: 'en', label: 'ENGLISH'},
    {value: 'ko', label: '한국어'},
    {value: 'ja', label: '日本語'},
    {value: 'zh', label: '简体中文'},
    {value: 'zh-CN', label: '简体中文'},
    {value: 'de', label: 'DEUTSCH'},
    {value: 'fr', label: 'FRANÇAIS'},
    {value: 'it', label: 'ITALIANO'},
    {value: 'es-ES', label: 'ESPAÑOL'},
    {value: 'es-MX', label: 'ESPAÑOL (MEXICO)'},
    {value: 'ru', label: 'РУССКИЙ'},
    {value: 'pl', label: 'POLSKI'},
    {value: 'pt-BR', label: 'PORTUGUÊS'},
    {value: 'ar', label: 'العربية'},
    {value: 'tr', label: 'TÜRKÇE'}
];

export default Languages;
